import { ActionCard } from '@playbooks/core/src/interfaces/ActionCard'

import { ActionCardsDbStore } from './actionCardsDbStore'
import { deleteFileQuestionsDb } from './dbService'
import { instance as autoLaunchedActionsDbStore } from './autoLaunchedActionsDbStore'
import { instance as funnelViewOpenedSeparatorsDbStore } from './funnelViewOpenedSeparatorsDbStore'

let isEnabled = true

const actionCardDbStore = new ActionCardsDbStore()

export function getIsStorageEnabled() {
  return isEnabled
}

export function setIsStorageActive(enable = true) {
  isEnabled = enable
}

export async function getLocalData(storageId: string) {
  const key = getActionCardDataKey(storageId)
  return await getLocalDataByKey(key)
}

export async function getLocalDataByKey(key: string) {
  const storageName = getStorageNameByKey(key)
  const data = localStorage.getItem(storageName)

  if (data) {
    // move data from local storage to IndexedDB
    const actionCardData = JSON.parse(data) as ActionCard
    await actionCardDbStore.save(key, null, actionCardData)
    localStorage.removeItem(storageName)
    return actionCardData
  } else {
    const data = await actionCardDbStore.get(key)
    return data ? data : null
  }
}

export async function saveLocalData(data: ActionCard, storageId: string) {
  const key = getActionCardDataKey(storageId)
  await actionCardDbStore.save(key, storageId, data)
}

export async function saveLocalDataByKey(data: ActionCard, key: string) {
  await actionCardDbStore.save(key, null, data)
}

export async function clearLocalData(storageId: string) {
  await actionCardDbStore.removeByStorageId(storageId)
  await funnelViewOpenedSeparatorsDbStore.remove(storageId)
  await autoLaunchedActionsDbStore.remove(storageId)
  await deleteFileQuestionsDb(storageId)
}

export function getStorageName(storageId: string) {
  const key = getActionCardDataKey(storageId)
  return getStorageNameByKey(key)
}

function getStorageNameByKey(key: string) {
  return `lnd_actionCardData_${key}`
}

function getActionCardDataKey(storageId: string) {
  const searchParams = new URL(location.href).searchParams
  const keys = [...searchParams.keys()].filter(key => key.startsWith('f_'))
  let key = storageId
  if (keys.length) key += `_${keys.map(key => `${key.slice(2)}=${searchParams.get(key)}`).join('_')}`
  return key
}
